import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowheadUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M10 7a1 1 0 0 1 .8.4l3 4A1 1 0 0 1 13 13H7a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 10 7Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgArrowheadUp);
export { ForwardRef as ReactComponent };
